import React from 'react';

import { useI18n } from '@change-corgi/core-react/i18n';
import { ButtonLink } from '@change-corgi/design-system-legacy/components/actions';
import { iconOpenInNew } from '@change-corgi/design-system-legacy/icons';

import type { SupporterVideo } from '../../shared/types';

import { useOpenVideo } from './hooks/useOpenVideo';

type LikeIconProps = {
	petitionId: string;
	video: SupporterVideo;
};

export const OpenVideo: React.FC<LikeIconProps> = ({ petitionId, video }) => {
	const {
		data: { link },
		actions: { handleOpenClick },
	} = useOpenVideo({ videoId: video.id, petitionId });

	const { translate } = useI18n();

	return (
		<ButtonLink
			to={link}
			size="small"
			mode="icon"
			icon={iconOpenInNew}
			variant="secondary"
			aria-label={translate('corgi.components.petition_video.actions.aria_label.open_video', {
				user_name: video.user?.shortDisplayName ?? '',
			})}
			data-testid={`supporter-video-${video.id}-open-button`}
			sx={{
				border: 'none',
				background: 'primary-greyBackground',
				'&:hover': {
					background: 'rgba(0,0,0,0.1)',
				},
			}}
			onClick={handleOpenClick}
		>
			Open video
		</ButtonLink>
	);
};
